<template>
  <div data-view="single-pin">
    <layout-single-frame>
      <template v-slot:content>
        <div class="container content grid-list-lg view-container">
          <PinForm
            :pin="pin"
            :confirm-trigger-label="$t('update_pin')"
            :is-loading="isLoading"
            :is-removing="isRemoving"
            :on-submit="updatePin"
            :on-remove="removePin"
          />
        </div>
      </template>
    </layout-single-frame>
  </div>
</template>

<script>
  import PinForm from '../../components/forms/pins/Edit';
  import { isStr } from '../../utils';

  export default {
    components: {
      PinForm,
    },
    data() {
      return {
        pin: {},
        isLoading: false,
        isRemoving: false,
      };
    },
    computed: {
      platforms() {
        return this.$store.getters['pins/platforms'];
      },
      visibilities() {
        return this.$store.getters['pins/visibilities'];
      },
      pages() {
        return this.$store.getters['pins/pages'];
      },
    },
    watch: {
      '$route.params': {
        handler(nextVal) {
          this.getPin(nextVal);
        },
        deep: true,
        immediate: true,
      },
    },
    methods: {
      getPin({id, country}) {
        const query = {
          id,
          country
        };

        return this.$store.dispatch('pins/getItem', query).then((nextPin) => {
          this.pin = nextPin;
          return nextPin;
        }).catch(err => err);
      },
      updatePin(pin) {
        const query = {
          ...pin,
          id: this.pin.id,
        };

        this.isLoading = true;
        return this.$store
          .dispatch('pins/updateItem', query)
          .then((nextPin) => {
            this.pin = nextPin;
            this.isLoading = false;
            this.$router.replace(`/pins/${nextPin.id}`);
            return nextPin;
          })
          .catch((err) => {
            this.isLoading = false;
            return err;
          });
      },
      removePin() {
        const query = {
          id: this.pin.id,
        };

        this.isRemoving = true;
        return this.$store
          .dispatch('pins/removeItem', query)
          .then((nextPin) => {
            this.isRemoving = false;
            this.$router.push('/pins');
            return nextPin;
          })
          .catch((err) => {
            this.isRemoving = false;
            return err;
          });
      },
    },
  };
</script>

<style lang="scss">
[data-view='single-pin'] {
  .view-container {
    max-width: 680px !important;
  }
}
</style>
